import { PAGE_TYPE } from "@/meta/common";
import { RouteRecordRaw } from "vue-router";
import { UserStore } from "@/stores/modules/user.ts";

const lianYunUser: RouteRecordRaw[] = [
    {
        path: "/lianYunUser",
        name: "LianYunUser",
        redirect: "/lianYunUser/infoManage",
        component: () => import("@/views/layouts/index.vue"),
        meta: {
            title: "企业管理",
            icon: "icon-yonghuguanli"
        },
        children: [
            {
                path: "infoManage",
                name: "InfoManage",
                component: () => import("@/views/pages/lianYunUser/infoManage/infoManage.vue"),
                meta: {
                    icon: "icon-user-3",
                    title: "用户列表",
                    pageType: PAGE_TYPE.LIST.code,
                    hidden: ({ userStore }: { userStore: UserStore }) => {
                        return userStore.isSAAS;
                    },
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_CUSTOMER_R"
                        },
                        {
                            label: "管理",
                            value: "ROLE_CUSTOMER_W"
                        }
                    ]
                }
            },
            {
                path: "userInfo/:userId",
                name: "UserInfo",
                component: () => import("@/views/pages/lianYunUser/infoManage/infoDetail/index.vue"),
                meta: {
                    title: "查看用户信息",
                    pageType: PAGE_TYPE.LOG.code,
                    hidden: true,
                    isNotShowHeader: true,
                    activeMenu: "InfoManage",
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_CUSTOMER_R"
                        }
                    ]
                }
            },
            {
                path: "enterpriseInfo/:id",
                name: "EnterPriseInfo",
                component: () => import("@/views/pages/lianYunUser/infoManage/enterpriseInfo/index.vue"),
                meta: {
                    title: "关联企业详情",
                    hidden: true,
                    isNotShowHeader: true,
                    activeMenu: "InfoManage",
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_CUSTOMER_R"
                        }
                    ]
                }
            },
            {
                path: "institutionApply",
                name: "InstitutionApply",
                component: () => import("@/views/pages/lianYunUser/institutionApply/index.vue"),
                meta: {
                    hidden: ({ userStore }: { userStore: UserStore }) => {
                        return userStore.isSAAS;
                    },
                    title: "机构认证管理",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "确认",
                            value: "ROLE_ORG_REVIEW"
                        }
                    ]
                }
            },
            {
                path: "institutionApply/info/:id",
                name: "InstitutionDetail",
                component: () => import("@/views/pages/lianYunUser/institutionApply/institutionDetail/index.vue"),
                meta: {
                    title: "查看机构认证详情",
                    hidden: true,
                    isNotShowHeader: true,
                    activeMenu: "InstitutionApply",
                    authOptions: [
                        {
                            label: "审核",
                            value: "ROLE_ORG_REVIEW"
                        }
                    ]
                }
            },
            {
                path: "institutionApply/audit/:id",
                name: "InstitutionAudit",
                component: () => import("@/views/pages/lianYunUser/institutionApply/institutionDetail/index.vue"),
                meta: {
                    title: "审核机构认证",
                    hidden: true,
                    isNotShowHeader: true,
                    activeMenu: "InstitutionApply",
                    authOptions: [
                        {
                            label: "审核",
                            value: "ROLE_ORG_REVIEW"
                        }
                    ]
                }
            },
            {
                path: "dealingsEnterprise",
                name: "DealingsEnterprise",
                component: () => import("@/views/pages/lianYunUser/dealingsEnterprise/index.vue"),
                meta: {
                    title: "往来企业管理",
                    pageType: PAGE_TYPE.LIST.code,
                    activeMenu: "DealingsEnterprise",
                    authOptions: [
                        {
                            label: "管理",
                            value: "ROLE_SUPPLIER_W"
                        }
                    ]
                }
            },
            {
                path: "dealingsEnterprise/add",
                name: "DealingsEnterpriseAdd",
                component: () => import("@/views/pages/lianYunUser/dealingsEnterprise/edit.vue"),
                meta: {
                    title: "新增往来企业",
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    activeMenu: "DealingsEnterprise",
                    hidden: true,
                    isNotShowHeader: true,
                    authOptions: [
                        { label: "查看", value: "ROLE_SUPPLIER_R" },
                        { label: "管理", value: "ROLE_SUPPLIER_W" }
                    ]
                }
            },
            {
                path: "dealingsEnterprise/edit/:id",
                name: "DealingsEnterpriseEdit",
                component: () => import("@/views/pages/lianYunUser/dealingsEnterprise/edit.vue"),
                meta: {
                    title: "修改往来企业",
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    activeMenu: "DealingsEnterprise",
                    hidden: true,
                    isNotShowHeader: true,
                    authOptions: [{ label: "管理", value: "ROLE_SUPPLIER_W" }]
                }
            },
            {
                path: "dealingsEnterprise/:id",
                name: "DealingsEnterpriseInfo",
                component: () => import("@/views/pages/lianYunUser/dealingsEnterprise/details.vue"),
                meta: {
                    title: "往来企业详情",
                    activeMenu: "DealingsEnterprise",
                    hidden: true,
                    isNotShowHeader: true
                }
            },
            {
                path: "financialInstitution",
                name: "FinancialInstitution",
                component: () => import("@/views/pages/lianYunUser/financialInstitution/index.vue"),
                meta: {
                    title: "金融机构管理",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.LIST.code
                }
            },
            {
                path: "businessManage",
                name: "BusinessManage",
                component: () => import("@/views/pages/lianYunUser/businessManage/businessManage.vue"),
                meta: {
                    hidden: ({ userStore }: { userStore: UserStore }) => {
                        if (userStore.isSAAS) {
                            // saas 未完成组织机构认证不展示
                            return !userStore.isOrganizationCertified;
                        }
                        return false;
                    },
                    title: "我的企业管理",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_COMPANY_R"
                        },
                        {
                            label: "管理",
                            value: "ROLE_COMPANY_W"
                        }
                    ]
                }
            }
        ]
    }
];

export default lianYunUser;
